import { Component, Input } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

export type AppSpinnerSize = "small" | "medium" | "large";

@Component({
  selector: "app-spinner",
  templateUrl: "./spinner.component.html",
  styleUrls: ["./spinner.component.scss"],
  imports: [MatProgressSpinnerModule],
})
export class SpinnerComponent {
  @Input() public size: AppSpinnerSize = "medium";

  public get diameter(): number {
    if (this.size === "small") return 20;
    if (this.size === "large") return 45;
    return 32;
  }
}
